import axios, { AxiosResponse } from "axios";

const baseURL = process.env.REACT_APP_API_CHECKING_PAGE;

const axiosCheckPageClient = axios.create({
  baseURL: baseURL,
  headers: {
    "Content-Type": "application/json",
  },
});

axiosCheckPageClient.interceptors.request.use(
  function (config: any) {
    return config;
  },

  function (error) {
    return Promise.reject(error);
  }
);

axiosCheckPageClient.interceptors.response.use(
  function (response: AxiosResponse) {
    return response.data;
  },

  function (error) {
    return Promise.reject(error);
  }
);

export { axiosCheckPageClient };
